import React from "react";
import Icon from "../../components/ui/Icon";
import {
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Box,
  useToast,
} from "@chakra-ui/react";
import SubmissionText from "../../components/ui/SubmissionText";
import { useNavigate } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { deleteReport } from "../../util/http";

export default function Item({ item, path }) {
  const navigate = useNavigate();

  const reportTime = new Date(item?.created_at);

  const token = localStorage.getItem("token");

  const toast = useToast();

  function showToast(title, description, status) {
    toast({
      title: title,
      description: description,
      status,
      duration: 3000,
      isClosable: true,
      position: "top",
    });
  }

  async function deleteHandler() {
    try {
      const response = await deleteReport(token, item.id);
      showToast(`${item?.service} successfully deleted`, "", "success");
      window.location.reload();
    } catch (error) {
      showToast(
        error?.response?.data.message || "something went wrong",
        "",
        "error"
      );
    }
  }

  const day = reportTime.getDate();
  const month = reportTime.getMonth();
  const year = reportTime.getFullYear();

  const hour = reportTime.getHours();
  const minute = reportTime.getMinutes();

  return (
    <Flex
      cursor="pointer"
      _hover={{ opacity: "80%", transition: "all", transitionDuration: "300" }}
      py="2"
      justify="space-between"
      // onClick={() => navigate(`/${path}`)}
    >
      <SubmissionText text={item.service} width="20%" />
      <SubmissionText
        text={`${day.toString().padStart(2, 0)}/${month
          .toString()
          .padStart(2, 0)}/${year} ${hour.toString().padStart(2, 0)}:${minute
          .toString()
          .padStart(2, 0)}`}
        width="20%"
        color="#8A9099"
      />
      <SubmissionText width="20%" text={item.department} />

      <Flex w="20%" justify="center">
        <Text
          bg={
            item.status === "pending"
              ? "rgba(178, 179, 179, 0.1)"
              : item.status === "queried"
              ? "rgba(255, 0, 0, 0.1)"
              : item.status === "replied"
              ? "rgba(234, 221, 202,0.5)"
              : "rgba(73, 201, 109, 0.1)"
          }
          fontWeight="medium"
          fontSize="15px"
          textAlign="center"
          color={
            item.status === "pending"
              ? "#828282"
              : item.status === "queried"
              ? "error.900"
              : item.status === "replied"
              ? "yellow.600"
              : "success.900"
          }
          py="8px"
          px="16px"
          borderRadius="0.75rem"
          style={{ textTransform: "capitalize" }}
        >
          {item.status}
        </Text>
      </Flex>

      <Flex align="center" justify="end" cursor="pointer" w="20%">
        <Box w="50%">
          <SubmissionText text={item.designation} fw="normal" />
        </Box>
        <Menu>
          <MenuButton
            _hover={{ bg: "#fff", text: "brand.900" }}
            _expanded={{ bg: "transparent" }}
            bg="transparent"
            colorScheme="purple"
            as={Button}
          >
            <Icon icon={<BsThreeDotsVertical />} />
          </MenuButton>
          <MenuList>
            <MenuItem
              display="flex"
              justify="center"
              align="center"
              cursor="pointer"
              gap="1rem"
              _focus={{ bg: "#fff" }}
              _hover={{ bg: "#fff" }}
              _expanded={{ bg: "#fff" }}
              onClick={() => navigate(`/report/${item.id}`)}
            >
              <Icon icon={<AiOutlineEye />} />
              <SubmissionText text="View Report" fw="normal" />
            </MenuItem>
            <MenuItem
              display="flex"
              justify="center"
              align="center"
              cursor="pointer"
              gap="1rem"
              _focus={{ bg: "#fff" }}
              _hover={{ bg: "#fff" }}
              _expanded={{ bg: "#fff" }}
              onClick={deleteHandler}
            >
              <Icon icon={<AiFillDelete />} />
              <SubmissionText text="Delete" fw="normal" />
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
}
